export default "__VITE_ASSET__C2zepHK9__"